export const playWhooshDing = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) {
    return;
  }
  const ctx = new Ctx();
  const now = ctx.currentTime;

  const len = Math.floor(ctx.sampleRate * 0.7);
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < len; i++) {
    data[i] = Math.random() * 2 - 1;
  }
  const noise = ctx.createBufferSource();
  noise.buffer = buf;
  const bp = ctx.createBiquadFilter();
  bp.type = "bandpass";
  bp.Q.value = 1.2;
  bp.frequency.setValueAtTime(300, now);
  bp.frequency.exponentialRampToValueAtTime(2600, now + 0.45);
  bp.frequency.exponentialRampToValueAtTime(900, now + 0.7);
  const wg = ctx.createGain();
  wg.gain.setValueAtTime(0.0001, now);
  wg.gain.exponentialRampToValueAtTime(0.22, now + 0.3);
  wg.gain.exponentialRampToValueAtTime(0.0001, now + 0.7);
  noise.connect(bp).connect(wg).connect(ctx.destination);
  noise.start(now);
  noise.stop(now + 0.7);

  const t = now + 0.55;
  [[1318.5, 0.14], [2637, 0.04]].forEach(([freq, vol]) => {
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.value = freq;
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(vol, t + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 1.2);
    osc.connect(g).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 1.25);
  });

  setTimeout(() => ctx.close(), 2000);
};
